import styled from 'styled-components';
import { MainHead } from '../../../components/common/head/MainHead';
import { pageInfo } from '../../../constants/pageInfo/pageInfo.constant';
import { useLayout } from '../../../hooks/screen/useLayout';
import { SellTractorButton } from '../../OpenMarket/components/SellTractorButton';
import { TabContainer } from '../../../components/common/tab/TabContainer';
import { useRef } from 'react';
import { ampli } from '../../../ampli';
import { useGetDownloadAppModalHeight } from '../../../hooks/modal/useGetDownloadAppModalHeight';
import { SellMachineCardGroup } from './components/SellMachineCardGroup';

type TabContainerRef = {
  selectTab: (index: number) => void;
};

export const MyInfoSellTractorListPage = () => {
  const tabContainerRef = useRef<TabContainerRef | null>(null);

  const downloadAppModalHeight = useGetDownloadAppModalHeight();

  useLayout({
    fixedHeader: (
      <MainHead
        backButton={{ isShow: true, directlyPassedURL: pageInfo.myInfoPage.path }}
        headerTitle={'판매 농기계 관리'}
      />
    ),
    fixedHeaderHeight: 48,
    fixedFooter: <SellTractorButton pageType={'myinfo'} />,
    fixedFooterHeight: 0,
  });

  return (
    <>
      <Container>
        <TabContainer
          ref={tabContainerRef}
          style={{
            width: 'calc(100% - 32px)',
            transform: 'translateX(16px)',
            position: 'sticky',
            top: `${40 + downloadAppModalHeight}px`,
            zIndex: 50,
            backgroundColor: 'white',
          }}
          tabInfos={[
            {
              text: '전체',
              element: <SellMachineCardGroup type={'ALL'} />,
              handleTabClick: () => {
                ampli.pvmClickMySellMachineTab({ title: 'ALL' });
              },
            },
            {
              text: '트랙터',
              element: <SellMachineCardGroup type={'tractor'} />,
              handleTabClick: () => {
                ampli.pvmClickMySellMachineTab({ title: 'tractor' });
              },
            },
            {
              text: '콤바인',
              element: <SellMachineCardGroup type={'combine'} />,
              handleTabClick: () => {
                ampli.pvmClickMySellMachineTab({ title: 'combine' });
              },
            },
            {
              text: '이앙기',
              element: <SellMachineCardGroup type={'transplanter'} />,
              handleTabClick: () => {
                ampli.pvmClickMySellMachineTab({ title: 'transplanter' });
              },
            },
          ]}
        />
      </Container>
    </>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1 0 0;
  align-self: stretch;
`;
